import styled from 'styled-components'
import { Button } from '..'
import { colors } from '../../constants'

export const NoteButton = styled(Button)`
    border-radius: 0;
    font-size: 13px;
    height: -moz-fit-content;
    height: fit-content;
    margin: 0;
    max-height: 38px;
    position: absolute;
    right: 0;
    top: 0;
`

export const NotePad = styled.div`
    background: ${colors.white};
    box-shadow: 1px 1px 4px 2px #0003;
    padding: 5px;
    position: fixed;
    transition: all 0.3s;

    & textarea {
        font-size: 13px;
    }

    ${({ height, width }) => `
    height: ${height}px;
    width: ${width}px;`}

    ${({ open, translate }) => {
        if (!open) {
            return 'transform: translate(0, 0) scale(0, 0);'
        }

        return translate ? `transform: translate(${translate[0]}%, ${translate[1]}%) scale(1, 1);` : 'transform: translate(0, 0) scale(1, 1);'
    }}
`

export const Background = styled.div`
    ${({ show }) =>
        show &&
        `
      height: 100%;
      left: 0;
      position: fixed;
      top: 0;
      width: 100%;
    `}
`

export const ModalTitle = styled.div`
    color: ${colors.bluedark};
    font-weight: bold;
    padding: 15px;
`
